module.exports = __webpack_public_path__ + "img/mv--avatar4--sp.f733c4e7.png";